import { render, staticRenderFns } from "./HeroAbout.vue?vue&type=template&id=4f141d46&scoped=true&"
import script from "./HeroAbout.vue?vue&type=script&lang=ts&"
export * from "./HeroAbout.vue?vue&type=script&lang=ts&"
import style0 from "./HeroAbout.vue?vue&type=style&index=0&id=4f141d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f141d46",
  null
  
)

export default component.exports